/**
 * Filter function for Search
 * @param data {array} - Original data for search
 * @param targetKeys {array} - Target keys
 * @param query {string} - Query text
 * @returns {array}
 */
export const searchFilter = (data = [], targetKeys = [], query = '') => {
  return data.filter(l => {
    return query
      .toLowerCase()
      .split(/\s+/)
      .map(q => {
        return targetKeys.some(s => {
          if (!l[s]) return false;
          return l[s].toLowerCase().indexOf(q) > -1;
        });
      })
      .every(result => result === true);
  });
};
